import { render, staticRenderFns } from "./MediaOwnerScreenTagSelect.vue?vue&type=template&id=a03205cc&"
import script from "./MediaOwnerScreenTagSelect.vue?vue&type=script&lang=js&"
export * from "./MediaOwnerScreenTagSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports